import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {DialogService} from '@shared/services/dialog-service';
import {PlatformCommand} from '@shared/commands/command-base';
import {select, Store} from '@ngrx/store';
import {FileManagerState} from '@features/file-manager/store/reducers/file-manager.reducer';
import {getFileStoreSelectedItems} from '@features/file-manager/store/selectors/file-manager.selectors';
import {IconViewModel} from '@features/file-manager/models/file-manager.model';
import {SnackBarService} from '@core/services/snack-bar.service';

@Injectable({
  providedIn: 'root',
})

export class SelectFileCommandHandler implements IPlatformCommandHandler {
  private selectedItems: IconViewModel[];
  constructor(
    private dialogService: DialogService,
    private fileManagerStore: Store<FileManagerState>,
    public snackBarService: SnackBarService,
  ) {
    this.fileManagerStore.pipe(select(getFileStoreSelectedItems)).subscribe((selectedItems: IconViewModel[]) => {
      this.selectedItems = selectedItems;
    });
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    if (this.selectedItems && this.selectedItems.length === 1 && this.selectedItems[0].type === 'File') {
      command.fieldValues['ItemId'] = this.selectedItems[0].itemId;
      command.fieldValues['ParentId'] = this.selectedItems[0].parentId;
      command.fieldValues['FileName'] = this.selectedItems[0].name;
      command.fieldValues['DriveId'] = this.selectedItems[0].driveId;
      command.fieldValues['RelativePath'] = this.selectedItems[0].relativePath;
      handler.executeCommand(command);
    } else {
      this.snackBarService.showError('File not selected');
    }
    return true;
  }
}
